import { Modal, Text } from '@nimbus-ds/components';
import { Trans } from 'react-i18next';
import { CancelAndConfirmButtons, Stack } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

interface ConfirmDeleteStockAndLocationModalProps {
  locationName: string;
  onConfirm: () => void;
  onClose: () => void;
}

function ConfirmDeleteStockAndLocationModal({
  locationName,
  onConfirm,
  onClose,
}: Readonly<ConfirmDeleteStockAndLocationModalProps>) {
  const t = useTranslationShipping();

  return (
    <>
      <Modal.Header
        title={t('locations.deleteSteps.confirmDeleteStockAndLocation.title', {
          name: locationName,
        })}
      />
      <Modal.Body padding="none">
        <Text>
          <Trans
            t={t}
            i18nKey="locations.deleteSteps.confirmDeleteStockAndLocation.description"
            components={{ bold: <strong /> }}
          />
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Stack spacing="base" justify="flex-end">
          <CancelAndConfirmButtons
            appearance="danger"
            onCancel={onClose}
            onConfirm={onConfirm}
            confirmText={t(
              'locations.deleteSteps.confirmDeleteStockAndLocation.confirm',
            )}
          />
        </Stack>
      </Modal.Footer>
    </>
  );
}

export default ConfirmDeleteStockAndLocationModal;
